<template>
    <div class="px-8 py-4">
        <strong class="text-lg">Smartlock toevoegen aan set</strong>
    </div>

    <div class="border-t px-8 pt-3 bg-gray-50">
        <div class="w-full flex flex-col">
            <div class="my-4 mb-12 flex justify-center">
                <!-- Steps -->
                <ol role="list" class="flex items-center" v-if="showUpsell">
                    <li
                        v-for="(step, stepIdx) in steps"
                        :key="step.name"
                        :class="[stepIdx !== steps.length - 1 ? 'pr-20 sm:pr-48' : '', 'relative']"
                        @click="navigateSteps(stepIdx)"
                    >
                        <template v-if="step.status === 'complete'">
                            <div class="absolute inset-0 flex items-center" aria-hidden="true">
                                <div class="h-0.5 w-full bg-dgreen" />
                            </div>
                            <a
                                href="#"
                                class="relative flex h-8 w-8 items-center justify-center rounded-full bg-dgreen hover:bg-dgreendark"
                            >
                                <span
                                    class="w-2.5 text-center absolute text-sm text-white font-bold"
                                    aria-hidden="true"
                                    >{{ stepIdx + 1 }}</span
                                >
                                <span class="sr-only">{{ step.name }}</span>
                                <div class="mt-14 absolute w-20 text-sm font-bold text-gray-800">{{ step.name }}</div>
                            </a>
                        </template>
                        <template v-else-if="step.status === 'current'">
                            <div class="absolute inset-0 flex items-center" aria-hidden="true">
                                <div class="h-0.5 w-full bg-gray-200" />
                            </div>
                            <a
                                href="#"
                                class="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-dgreen bg-white"
                                aria-current="step"
                            >
                                <span
                                    class="w-2.5 text-center absolute text-sm text-dgreen font-bold"
                                    aria-hidden="true"
                                    >{{ stepIdx + 1 }}</span
                                >
                                <span class="sr-only">{{ step.name }}</span>
                                <div class="mt-14 absolute text-sm w-20 font-bold text-gray-800">{{ step.name }}</div>
                            </a>
                        </template>
                        <template v-else>
                            <div class="absolute inset-0 flex items-center" aria-hidden="true">
                                <div class="h-0.5 w-full bg-gray-200" />
                            </div>
                            <a
                                href="#"
                                class="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white"
                                aria-current="step"
                            >
                                <span
                                    class="w-2.5 text-center absolute text-sm text-gray-600 font-bold"
                                    aria-hidden="true"
                                    >{{ stepIdx + 1 }}</span
                                >
                                <span class="sr-only">{{ step.name }}</span>
                                <span class="mt-14 text-sm font-bold text-gray-800">{{ step.name }}</span>
                            </a>
                        </template>
                    </li>
                </ol>
            </div>
        </div>

        <!-- Step 1 - Smartlocks -->
        <div v-if="active == 1">
            <!-- Loader -->
            <div class="flex w-full">
                <fa
                    :icon="['fad', 'spinner-third']"
                    class="text-dgreen opacity-80 fa-spin my-8 mx-auto w-12 h-12"
                    v-if="loadingStep1"
                />
            </div>

            <RadioGroup v-model="selectedSmartlock">
                <div class="flex flex-col space-y-4">
                    <RadioGroupOption
                        as="template"
                        v-for="smartlock in availableOptions.options"
                        :key="smartlock.id"
                        :value="smartlock"
                        v-slot="{ checked, active }"
                    >
                        <div
                            :class="[
                                checked ? 'border-transparent' : 'border-gray-300',
                                active ? 'border-dgreen2 ring-1 ring-dgreen2' : '',
                                'relative flex cursor-pointer rounded-lg border bg-white transition-all p-4 md:p-6 shadow focus:outline-hidden',
                            ]"
                        >
                            <div
                                class="rounded-r-md absolute left-0 top-0 mt-4 text-white text-xs bg-dgreen px-3 py-1 z-10"
                                v-if="smartlock.id == 3525"
                            >
                                Aanbevolen
                            </div>
                            <span class="md:flex flex-between w-full relative">
                                <div class="pl-8 md:w-48 relative w-full flex md:block justify-center flex-col">
                                    <input
                                        type="radio"
                                        class="absolute left-2 top-1/2 -translate-y-1/2"
                                        :checked="checked"
                                    />
                                    <vue-picture
                                        :image="
                                            selectedColorVersion &&
                                            selectedColorVersionRadio.option_id == smartlock.option.id &&
                                            selectedColorVersion.option.image
                                                ? selectedColorVersion.option.image
                                                : smartlock.option.image
                                        "
                                        :style="'w-48 mx-auto'"
                                    />
                                    <fa
                                        :icon="['fad', 'spinner-third']"
                                        class="text-white opacity-80 w-8 h-8 mr-2 fa-spin absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2"
                                        v-if="smartlock.loading"
                                    />

                                    <!-- Colors -->
                                    <RadioGroup
                                        v-model="selectedColorVersionRadio"
                                        class="mt-2 md:mt-0 md:ml-6 mx-auto"
                                        v-if="smartlock.option.colors && smartlock.option.colors.length > 1"
                                    >
                                        <div class="space-x-2 flex pt-5 items-center">
                                            <RadioGroupOption
                                                as="template"
                                                v-for="color in smartlock.option.colors"
                                                :key="color.id"
                                                :value="color"
                                                v-slot="{ active, checked }"
                                                @click="changeColor(color, smartlock)"
                                            >
                                                <div
                                                    :class="[
                                                        active && checked ? 'ring-3' : '',
                                                        !active && checked ? 'ring-2' : '',

                                                        'ring-dgreen -m-0.5 relative p-0.5 ring-offset-1 rounded-full flex items-center justify-center cursor-pointer focus:outline-hidden',
                                                    ]"
                                                >
                                                    <!-- color.id == cylinder.color.id ? 'ring-offset-1 ring-2' : '', -->
                                                    <RadioGroupLabel as="p" class="sr-only">{{
                                                        color.name
                                                    }}</RadioGroupLabel>
                                                    <span
                                                        aria-hidden="true"
                                                        :class="[
                                                            background(color),
                                                            'h-6 w-6 border border-black/10 rounded-full',
                                                        ]"
                                                    />
                                                </div>
                                            </RadioGroupOption>
                                        </div>
                                    </RadioGroup>
                                </div>

                                <div class="flex flex-col grow px-4 w-full">
                                    <strong
                                        v-if="
                                            selectedColorVersion &&
                                            selectedColorVersionRadio.option_id == smartlock.option.id
                                        "
                                        >{{ selectedColorVersion.value }}</strong
                                    >
                                    <strong v-else>{{ smartlock.value }}</strong>

                                    <RadioGroupDescription as="ul" class="text-sm my-4">
                                        <li
                                            v-for="(usp, index) in smartlock.option.product.usps"
                                            class="flex my-2 md:my-0 items-center"
                                        >
                                            <fa :icon="['fal', 'check']" class="text-dgreen mr-2 w-4" />
                                            <span class="inline-block" v-html="usp" />
                                        </li>
                                    </RadioGroupDescription>
                                </div>
                                <strong class="block text-xl mt-0">{{ price(smartlock.option.price) }}</strong>
                            </span>
                            <span
                                :class="[
                                    active ? 'border' : 'border-2',
                                    checked ? 'border-dgreen2' : 'border-transparent',
                                    'pointer-events-none absolute -inset-px rounded-lg',
                                ]"
                                aria-hidden="true"
                            />
                        </div>
                    </RadioGroupOption>
                </div>
            </RadioGroup>
        </div>

        <!-- Step 2 - Accessoires -->
        <div v-if="active == 2">
            <!-- Loader -->
            <div class="flex w-full">
                <fa
                    :icon="['fad', 'spinner-third']"
                    class="text-dgreen opacity-80 fa-spin my-8 mx-auto w-12 h-12"
                    v-if="loadingStep2"
                />
            </div>

            <strong class="block mb-4">Aanbevolen accessoires</strong>

            <Transition name="pop">
                <div class="mt-2">
                    <div class="space-y-2">
                        <div
                            class="rounded-lg bg-white hover:border-gray-500 transition-all border cursor-pointer relative items-center"
                            v-for="value in availableAccessoires"
                            :class="selectedAccessoires.includes(value.id) ? 'border-dgreen2' : 'bg-white'"
                            :key="value.id"
                        >
                            <div
                                class="rounded-r-md absolute left-0 top-0 mt-4 text-white text-xs bg-dgreen px-3 py-1 z-10"
                                v-if="value.id == 144 || value.id == 80 || value.id == 76 || value.id == 72"
                            >
                                Aanbevolen
                            </div>
                            <label :for="value.id" class="flex items-center px-4 py-2 cursor-pointer md:text-sm">
                                <input
                                    type="checkbox"
                                    :id="value.id"
                                    :value="value.id"
                                    v-model="selectedAccessoires"
                                    class="h-5 w-5 border-gray-300 rounded text-dgreen3 transition focus:ring-0 mr-6"
                                />
                                <vue-picture :image="value.image" :style="'h-32'" class="mr-4" />
                                <span class="grow">
                                    <strong class="inline-block mb-2 text-base">{{ value.name }}</strong>

                                    <!-- <info-modal :title="value.value" :body="value.description" :infoIcon="true">
                                </info-modal> -->
                                    <ul class="hidden md:block">
                                        <li v-for="(usp, index) in value.usps">
                                            <fa :icon="['fal', 'check']" class="text-dgreen mr-2 w-4" />
                                            <span v-html="usp" />
                                        </li>
                                    </ul>
                                    <!-- <a
                                        class="text-dgreen2 ml-4"
                                        :href="value.url"
                                        target="_blank"
                                        :title="'Bekijk ' + value.value"
                                        >Bekijk product</a
                                    > -->
                                </span>
                                <span v-if="value.price" class="ml-2 font-bold text-lg">{{ price(value.price) }}</span>
                            </label>

                             <ul class="md:hidden px-4 pb-4">
                                <li v-for="(usp, index) in value.usps">
                                    <fa :icon="['fal', 'check']" class="text-dgreen mr-2 w-4" />
                                    <span v-html="usp" />
                                </li>
                            </ul>

                            <!-- <fa
                                :icon="['fal', 'check-circle']"
                                class="hidden md:inline-block text-dgreen2 absolute right-6 mt-0.5 w-4"
                                v-if="value.id == values[option.id].id"
                            /> -->
                        </div>
                    </div>
                </div>
            </Transition>
        </div>

        <div v-if="active == 3" class="relative">
            <div v-if="selectedColorVersion" class="mb-4 border border-gray-400 rounded-md bg-white px-4 py-3 w-fit">
                <strong class="text-sm">{{ selectedColorVersion.value }}</strong>
                <vue-picture :image="selectedColorVersion.option.image" :style="'w-24 mx-auto'" />
            </div>
            <div v-else-if="selectedSmartlock" class="mb-4 border border-gray-400 rounded-md bg-white px-4 py-3 w-fit">
                <strong class="text-sm">{{ selectedSmartlock.value }}</strong>
                <vue-picture :image="selectedSmartlock.option.image" :style="'w-24 mx-auto'" />
            </div>
            <label class="text-base font-bold leading-6 text-gray-900"
                >Op welke cilinders(s) moet de smart lock komen?</label
            >
            <p class="text-gray-600 my-2">De smart lock wordt op de binnenzijde van de cilinder geplaatst.</p>

            <div v-for="(cylinder, index) in cylinders">
                <div
                    class="rounded-lg bg-white hover:border-gray-600 transition-all border cursor-pointer relative items-center mt-4 select-none w-full md:w-fit"
                    :class="{
                        'border-dgreen2': selectedCylinders.includes(index),
                    }"
                    :key="index"
                >
                    <label :for="index" class="flex items-center px-4 py-2 cursor-pointer">
                        <input
                            type="checkbox"
                            :id="index"
                            v-model="selectedCylinders"
                            :value="index"
                            class="h-5 w-5 border-gray-300 rounded text-dgreen2 transition focus:ring-0 mr-6"
                        />

                        <span class="flex items-center">
                            <div class="inline-block">
                                <span class="hidden md:inline-block">Cilinder</span> {{ index + 1 }}
                            </div>
                            <div class="inline-block font-bold ml-4 mr-4">{{ cylinder.a }}/{{ cylinder.b }}</div>
                            <div class="md:w-[400px] hidden md:flex items-center justify-end">
                                <img :src="totals.cylinders[index].image" class="h-20" />
                            </div>
                            <div class="my-2 flex">
                                <fa :icon="['fal', 'arrow-left-long']" class="ml-2 mt-4 hidden md:block" />
                                <div class="border border-gray-400 border-dashed rounded-xl p-2 md:p-4">
                                    Smart lock op <strong>{{ cylinder.b }}</strong>
                                </div>
                            </div>
                        </span>
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="bg-gray-50 py-6 px-8 flex justify-between rounded-b-xl">
        <div>
            <button class="button bg-white default" v-if="active > 1" @click="active = active - 1">
                <fa :icon="['fal', 'angle-left']" class="mr-2" /> Terug
            </button>
        </div>
        <div class="relative" v-if="active == 1 && showUpsell">
            <div class="bg-white opacity-50 absolute inset-0 h-full w-full" v-if="!selectedSmartlock"></div>
            <button class="button green" @click="active = 2">
                Volgende stap <fa :icon="['fal', 'angle-right']" class="ml-2" />
            </button>
        </div>

        <div class="relative" v-if="active == 2 && cylinder === false && showUpsell">
            <div class="bg-white opacity-50 absolute inset-0 h-full w-full" v-if="!selectedCylinders"></div>
            <button class="button green" @click="active = 3">
                <span v-if="!selectedAccessoires.length">
                    <span class="md:hidden">Doorgaan</span>
                    <span class="hidden md:inline-block">Doorgaan zonder accessoires</span>
                </span>
                <span v-else-if="cylinder === false">Kies cilinder(s)</span>
                <span v-else>Volgende stap</span>
                <fa :icon="['fal', 'angle-right']" class="ml-2" />
            </button>
        </div>

        <div class="relative" v-if="active == 2 && cylinder !== false && showUpsell">
            <button class="button green" @click="addSmartlock()">
                <span v-if="!selectedAccessoires.length">Doorgaan zonder accessoires</span>
                <span v-else>Smart lock toevoegen</span>
                <fa :icon="['fal', 'angle-right']" class="ml-2" />
            </button>
        </div>

        <div class="relative" v-if="!showUpsell">
            <button class="button green" @click="addSmartlock">
                <span>Smart lock toevoegen</span>
                <fa :icon="['fal', 'angle-right']" class="ml-2" />
            </button>
        </div>

        <div class="relative" v-if="active == 3">
            <div
                class="bg-white opacity-50 absolute inset-0 h-full w-full"
                v-if="!selectedCylinders || (cylinder === false && !selectedCylinders.length)"
            ></div>
            <button class="button green" @click="addSmartlock">
                Smart lock toevoegen <fa :icon="['fal', 'angle-right']" class="ml-2" />
            </button>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';

const emit = defineEmits(['close']);

const selectedSmartlock = ref(false);
const selectedColorVersionRadio = ref(false);
const selectedColorVersion = ref(false);
const selectedCylinders = ref([]);
const selectedAccessoires = ref([]);

const availableOptions = ref([]);
const availableAccessoires = ref([]);

const loadingStep1 = ref(true);
const loadingStep2 = ref(false);

const active = ref(1);

const props = defineProps({
    options: Object,
    totals: Object,
    cylinders: Array,
    cylinder: Number | Boolean,
    product: Object,
    showUpsell: {
        type: Boolean,
        default: true,
    }
});

onMounted(() => {
    fetchOptions();
});

const inBrowser = typeof window !== 'undefined';

const steps = computed(() => {
    let steps = [
        {
            name: 'Smart lock',
            step: 1,
            status: active.value > 1 ? 'complete' : active.value == 1 ? 'current' : 'complete',
        },
        {
            name: 'Accessoires',
            step: 2,
            status: active.value > 2 ? 'complete' : active.value == 2 ? 'current' : 'upcoming',
        },
        {
            name: 'Cilinder(s)',
            step: 3,
            status: active.value > 3 ? 'complete' : active.value == 3 ? 'current' : 'upcoming',
        },
    ];

    if (props.cylinder !== false) {
        steps = steps.slice(0, 2);
    }

    return steps;
});

function changeColor(color, smartlock) {
    selectedColorVersion.value = availableOptions.value.versions.find(
        (element) => element.attribute_option_id == color.id
    );

    fetchAccessoires();
}

function background(color) {
    if (color.name == 'RVS') {
        return 'bg-gray-300';
    }
    if (color.name == 'Zilver') {
        return 'bg-gray-300';
    }
    if (color.name == 'Zwart') {
        return 'bg-black';
    }
}

function navigateSteps(step) {
    if (active.value == 1) {
        if (selectedSmartlock.value.id) {
            active.value = step + 1;
        }
    } else {
        active.value = step + 1;
    }
}

function fetchOptions() {
    axios
        .get('/configurable/smartlock-options/' + props.product.id, {})
        .then(function (response) {
            availableOptions.value = response.data;
        })
        .finally(function () {
            loadingStep1.value = false;
        });
}

function fetchAccessoires() {
    loadingStep2.value = true;

    let id = false;

    if (selectedColorVersion.value) {
        id = selectedColorVersion.value.option.id;
    } else {
        id = selectedSmartlock.value.option.id;
    }

    axios
        .get('/configurable/smartlock-accessoires/' + id, {})
        .then(function (response) {
            availableAccessoires.value = response.data;
            selectedAccessoires.value = [];
        })
        .finally(function () {
            loadingStep2.value = false;
        });
}

watch(selectedSmartlock, (newValue, oldValue) => {
    // Reset color images
    // availableOptions.value.forEach(function (item, key) {
    //     item.option.version_image = false;
    // });

    // // Set new color value
    // if (newValue.option.colors.length) {
    //     selectedColorVersion.value = newValue.option.colors[0];
    // } else {
    //     selectedColorVersion.value = false;
    // }

    // Get accessoires
    fetchAccessoires();
});

if (props.cylinder !== false) {
    selectedCylinders.value.push(props.cylinder);
}

function addSmartlock(index) {
    if (inBrowser) {
        window.mitt.emit('setUpsellItems', selectedAccessoires.value);
    }

    if (selectedColorVersion.value) {
        selectedSmartlock.value = selectedColorVersion.value;
    }   


    selectedCylinders.value.forEach((element) => {
        window.mitt.emit('selectSmartlock', {
            smartlock: selectedSmartlock.value,
            cylinder: element,
        });
    });

    emit('close');
}
</script>
